import { BookingBuilder, CustomItemPayload, ENetworkRequestStatus } from 'services/BackendApi';
import { SearchDomain, initialState as searchInitialState } from './subdomains/search/model';

import { IHotelSubdomain, hotelInitialState } from './subdomains/hotel/model';
import { IRequestSubdomain, requestInitialState } from './subdomains/request/model';
import { IResponseSubdomain, responseInitialState } from './subdomains/response/model';
import { hotelModalInitialState, IHotelModalSubdomain } from './subdomains/hotelModal/model';
import { BestOptionSubdomain, bestOptionInitialState } from './subdomains/bestOption/model';
import { IHotelAccommodationSubdomain, hotelAccommodationInitialState } from './subdomains/hotelAccommodation/model';
import { LiveRatesSubdomain, liveRatesInitialState } from './subdomains/liveRates/model';
import { IBasketSubdomain, basketInitialState } from './subdomains/basket/model';
import { ITransfersSubdomain, transfersInitialState } from './subdomains/transfers/model';

export interface CustomItemSubdomain {
  payload: CustomItemPayload | null;
}

export interface NewProposalPayload {
  name: string;
  userUuid: string;
  guestFirstName: string;
  guestLastName: string;
  guestTitle: string;
}

export interface BookingBuilderDomain {
  currentBookingBuilder: BookingBuilder | null;
  hotelUuid: string | null;
  updateBookingRequestStatus: ENetworkRequestStatus;

  // these are here for forward compat reasons
  // they were found by loading up a booking and seeing what was inside the base booking data object
  uuid: string | null;
  checkInDate: string | null;
  checkOutDate: string | null;
  numAdults: number | null;
  agesOfAllChildren: number[];
  guestTitle: string | null;
  guestFirstName: string | null;
  guestLastName: string | null;
  guestEmail: string | null;
  isRepeatGuest: boolean;
  specialRequests: string[];
  comments: string | null;
  status: string | null;
  flightArrivalDate: string | null;
  flightArrivalNumber: string | null;
  flightDepartureDate: string | null;
  flightDepartureNumber: string | null;
  travelAgentUserUuid: string | null;
  proposalUuid: string | null;
  bookingHash: string | null;
  hotelName: string | null;
  overrideTotal: any | null;
  bookingComments: any | null;
  internalComments: any | null;
  createdAt: any | null;
  updatedAt: any | null;
  deletedAt: any | null;
  clientUuid: any | null;
  isTAMarginApplied: boolean;
  taMarginType: string | undefined;
  taMarginAmount: string | undefined;
  customItem: CustomItemSubdomain;
  isPristine: boolean;
  latestBookingOperation: string | null;
  search: SearchDomain;

  requestSubdomain: IRequestSubdomain;
  responseSubdomain: IResponseSubdomain;
  hotelSubdomain: IHotelSubdomain;
  hotelModalSubdomain: IHotelModalSubdomain;
  bestOptionSubdomain: BestOptionSubdomain;
  hotelAccommodationSubdomain: IHotelAccommodationSubdomain;
  liveRatesSubdomain: LiveRatesSubdomain;
  basketSubdomain: IBasketSubdomain;
  transfersSubdomain: ITransfersSubdomain;
}

export const initialState: BookingBuilderDomain = {
  currentBookingBuilder: null,
  hotelUuid: null,
  updateBookingRequestStatus: ENetworkRequestStatus.IDLE,

  // these are here for forward compat reasons
  // they were found by loading up a booking and seeing what was inside the base booking data object
  uuid: null,
  checkInDate: null,
  checkOutDate: null,
  numAdults: null,
  agesOfAllChildren: [],
  guestTitle: null,
  guestFirstName: null,
  guestLastName: null,
  guestEmail: null,
  isRepeatGuest: false,
  specialRequests: [],
  comments: '',
  taMarginType: 'percentage',
  taMarginAmount: '',
  status: null,
  flightArrivalDate: null,
  flightArrivalNumber: null,
  flightDepartureDate: null,
  flightDepartureNumber: null,
  travelAgentUserUuid: null,
  proposalUuid: null,
  bookingHash: null,
  hotelName: null,
  overrideTotal: null,
  bookingComments: null,
  internalComments: null,
  createdAt: null,
  updatedAt: null,
  deletedAt: null,
  clientUuid: null,
  isTAMarginApplied: true,
  customItem: {
    payload: null,
  },
  isPristine: true,
  latestBookingOperation: null,
  search: searchInitialState,


  requestSubdomain: requestInitialState,
  responseSubdomain: responseInitialState,
  hotelSubdomain: hotelInitialState,
  hotelModalSubdomain: hotelModalInitialState,
  bestOptionSubdomain: bestOptionInitialState,
  hotelAccommodationSubdomain: hotelAccommodationInitialState,
  liveRatesSubdomain: liveRatesInitialState,
  basketSubdomain: basketInitialState,
  transfersSubdomain: transfersInitialState,
};

export enum ERoomRateType {
  STATIC = 'static',
  LIVE = 'live',
}
